module.exports = __webpack_public_path__ + "img/delay_3.7a9654cc.svg";